import './agent-view.component.ajscss';

import { UserTrackingFunction } from '@tracking/models/tracking-function';
import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './agent-view.component.ajs.html';

const MODULE_NAME = 'contactAgentView';

class AgentViewControler implements IComponentController {
  public name = MODULE_NAME;
  public UserTrackingFunction = UserTrackingFunction;
  $onInit() {}
}

export class AgentView implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {};
  controller = [AgentViewControler];
}

export default MODULE_NAME;
